export class FinalizeDistributionDto {
    public distributionId:number;
    public payoutPersonalMessage:string;
    public sendEmail:boolean;
    public finalizeDate:Date;
    public metaFileLinkIds?: number[];
}